import 'angular-ui-bootstrap/src/stackedMap/stackedMap';
import 'angular-ui-bootstrap/src/modal/modal';

import windowTemplate from './window.template.jade';
import backdropTemplate from './backdrop.template.jade';

export default angular.module('ui.cian.modal.adapter',
	['ui.bootstrap.stackedMap',
		'ui.bootstrap.modal'
	])
	.run(['$templateCache', ($templateCache) => {
		$templateCache.put('uib/template/modal/window.html', windowTemplate);
		$templateCache.put('uib/template/modal/backdrop.html', backdropTemplate);
	}])
	.name;



// WEBPACK FOOTER //
// ./~/@cian/ui/app/adapters/ui.bootstrap.modal/modal.module.jsm